import EventBus from 'event_bus'
import Cookies from 'js-cookie'

export default class RegistrationFence {
  constructor ($el) {
    this.$el = $el
    this.url = $el.data('url')
    this.addEventHandlers()
    this.open()
  }

  addEventHandlers () {
    this.$el.on('click', '.js-registration-fence-close', this.onClose.bind(this))
    this.$el.on('click', '.js-registration-fence-overlay', this.onOverlayClick.bind(this))
    this.$el.on('click', '.js-registration-fence-submit', this.onSubmit.bind(this))
  }

  onClose () {
    this.$el.fadeOut()
    Cookies.set('registration_fence_uneligible', 'true', { expires: 2, path: '/' })
    $('body').css('overflow', 'auto')
  }

  onOverlayClick ($event) {
    if ($event.currentTarget === $event.target) {
      $('.js-registration-fence-close', this.$el).click()
    }
  }

  onSubmit ($event) {
    $event.preventDefault()

    const $form = $('.js-registration-fence-form', this.$el)
    $.ajax({
      method: 'POST',
      url: $form.attr('action'),
      data: $form.serialize(),
      dataType: 'json'
    }).success((response) => {
      $(this.$el).html(response.body)

      EventBus.trigger('tracking:registrationSuccess', response.webtrekk)
      Cookies.set('registration_fence_uneligible', 'true', { expires: 2, path: '/' })
    }).error((xhr) => {
      if (xhr.status === 400) {
        $(this.$el).html(xhr.responseJSON.body)
      }
    })
  }

  open () {
    if (this.isEligible(Cookies.get('registration_fence_uneligible'))) {
      $.get(this.url, (data) => {
        this.$el.hide()
        this.$el.html(data)
        this.$el.delay(2000).fadeIn(() => {
          $('body').css('overflow', 'hidden')
          EventBus.trigger('tracking:manualEventTrack', { action_type: 'appear', $elem: this.$el.children().first() })
        })

        $('.input--login', this.$el).focus()
      })
    }
  }

  isEligible (cookie) {
    return cookie === undefined || cookie !== 'true'
  }
}

export const bind = () => {
  const $elem = $('.js-registration-fence')
  if ($elem.length > 0) {
    new RegistrationFence($('.js-registration-fence'))
  }
}
